import { signInWithGoogle, signInWithTwitter, signInWithEmail, getRedirectResult } from "@/lib/auth/client";
import Head from "next/head";
import { useState, useEffect, FormEvent } from "react";
import { useRouter } from "next/router";
import LoadingDots from "@/components/app/loading-dots";
import toast, { Toaster } from "react-hot-toast";

import { authStateChanges } from "@/lib/auth/client";
import clsx from "clsx";
import { InputElement } from "@/components/InputElement";
import BlurImage from "@/components/BlurImage";
import { useModal } from "@/lib/hooks/useModal";
import { Twitter } from "react-feather";
import Spinner from "@/components/Spinner";

export default function Login() {
  const { openModal, closeModal } = useModal();

  const [processingGoogle, setProcessingGoogle] = useState(false);
  const [processingTwitter, setProcessingTwitter] = useState(false);

  const [checkInbox, setCheckInbox] = useState(false);

  const [checkRedirect, setCheckRedirect] = useState(false);

  const [email, setEmail] = useState<string>('');

  // Get error message added by next/auth in URL.
  const router = useRouter();
  const { error } = router.query;

  useEffect(() => {
    const errorMessage = Array.isArray(error) ? error.pop() : error;
    errorMessage && toast.error(errorMessage);
    setProcessingGoogle(false)
    setProcessingTwitter(false)
  }, [error]);

  useEffect(() => {
    getRedirectResult()
    .then(({user}) => {
      if (user) {
        setCheckRedirect(true)
      }
    })
  }, []);

  return (
    <div className="flex flex-col justify-center w-full min-h-screen">

      <main>
        <div className="min-h-screen mx-auto bg-white">
          <div className="flex items-center justify-center min-h-screen pt-4 pb-8 mx-auto overflow-hidden lg:pb-12 bg-gray-50">
            <div className="container relative px-3 mx-auto my-autox max-w-7xl sm:px-6 lg:px-8" id="features">

              <section className="flex flex-col items-center drop-shadow-2xl md:flex-row md:cardcurious">

                <div className="hidden relative w-full h-[75vh] bg-gray-700 md:block md:w-1/2 xl:w-2/3 rounded-l-2xl">
                  <img src="/images/creator-at-work.jpeg" alt="" className="absolute object-cover w-full h-full brightness-50 rounded-l-2xl" />
                  <div className="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center text-white">
                    <div className="flex flex-col px-4 space-y-2">
                      <p className="text-6xl font-Syne">
                        Supercharge<br /> your link-in-bio🔥
                      </p>
                      <p className="hidden text-3xl">
                        for everyone!
                      </p>
                      <p className="mt-4">Link-in-bio, personal portfolio, landing page and more — anything goes</p>
                    </div>
                  </div>
                </div>

                <div className="flex items-center justify-center w-full h-[75vh] px-6 bg-white md:max-w-md lg:max-w-full md:mx-auto md:w-1/2 xl:w-1/3 lg:px-16 xl:px-12 rounded-xl md:rounded-r-2xl">

                  {!checkInbox && !checkRedirect && <div className="w-full space-y-6">

                    <img src="/images/apple-touch-icon.png" height={36} width={36} alt="Logo" />

                    <h1 className="font-semibold leading-tight text-gray-500 text-">Login / Create new account</h1>

                    <form onSubmit={
                      (event: FormEvent<HTMLFormElement>) => {
                        event.preventDefault();
                        signInWithEmail(email)
                          .then(() => {
                            window.localStorage.setItem('emailForSignIn', email);
                            setEmail('');
                            setCheckInbox(true)
                          });
                      }}
                      className="space-y-3" action="#" method="POST">
                      <div className="">
                        <label className="block text-gray-700">Email Address</label>
                        <InputElement onChange={(e) => setEmail(e.target.value.toLowerCase())} value={email} name="email" type="email" placeholder="Enter Email Address" required={true} />
                      </div>

                      <div className="hidden mt-2 text-right">
                        <a href="#" className="text-sm font-semibold text-gray-700 hover:text-blue-700 focus:text-blue-700">Forgot Password?</a>
                      </div>

                      <button type='submit' className="block w-full px-4 py-3 mt-6 font-semibold text-white bg-gray-700 hover:bg-gray-500 focus:bg-gray-400 rounded-xl">Continue</button>
                    </form>

                    <hr className="w-full border-gray-300" />

                    <div className="space-y-4">
                      <button
                        disabled={processingGoogle}
                        onClick={() => {
                          setProcessingGoogle(true);
                          signInWithGoogle()
                            .catch((e) => {
                              setProcessingGoogle(false)
                              setProcessingGoogle(false)
                              toast.error(e.message)
                            });
                        }} type="button"
                        className={clsx("block w-full px-4 font-medium text-gray-500 bg-white border border-gray-300 rounded-xl hover:bg-gray-100 focus:bg-gray-100", processingGoogle ? "cursor-not-allowed bg-gray-600x py-5" : "bg-blackx py-3")}>
                        <div className="flex items-center justify-center">

                          {processingGoogle ? (
                            <LoadingDots color="#111" />
                          ) : (<>
                            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" className="w-6 h-6" viewBox="0 0 48 48"><defs><path id="a" d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z" /></defs><clipPath id="b"><use xlinkHref="#a" overflow="visible" /></clipPath><path clipPath="url(#b)" fill="#FBBC05" d="M0 37V11l17 13z" /><path clipPath="url(#b)" fill="#EA4335" d="M0 11l17 13 7-6.1L48 14V0H0z" /><path clipPath="url(#b)" fill="#34A853" d="M0 37l30-23 7.9 1L48 0v48H0z" /><path clipPath="url(#b)" fill="#4285F4" d="M48 48L17 24l-4-3 35-10z" /></svg>
                            <span className="ml-4">
                              Continue
                              with
                              Google
                            </span>
                          </>)}
                        </div>
                      </button>

                      <button
                        disabled={processingTwitter}
                        onClick={() => {
                          setProcessingTwitter(true);
                          signInWithTwitter().catch((e) => {
                            setProcessingTwitter(false)
                            setProcessingGoogle(false)
                            toast.error(e.message)
                          });
                        }} type="button"
                        className={clsx("block w-full px-4 font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 focus:bg-gray-100", processingTwitter ? "cursor-not-allowed bg-gray-600x py-5" : "bg-blackx py-2.5")}>
                        <div className="flex items-center justify-center">

                          {processingTwitter ? (
                            <LoadingDots color="#111" />
                          ) : (<>
                            <Twitter className="fill-[#76A9EA] stroke-[#76A9EA]" />
                            <span className="ml-4">
                              Continue
                              with
                              Twitter
                            </span>
                          </>)}
                        </div>
                      </button>
                    </div>

                    <p className="hidden space-x-1">
                      <span>Need an account?</span>
                      <a href="#" className="font-semibold text-blue-500 hover:text-blue-700">Create an
                        account
                      </a>
                    </p>

                  </div>
                  }
                  {checkInbox && <div className="w-full space-y-6">

                    <img src="/images/apple-touch-icon.png" height={36} width={36} alt="Logo" />

                    <h1 className="font-bold leading-tight text-gray-500 text-">Please check your email inbox for a link to login</h1>

                  </div>}
                  {checkRedirect && <div className="w-full space-y-6">

                    <img src="/images/apple-touch-icon.png" height={36} width={36} alt="Logo" />

                    <Spinner/>

                  </div>}
                </div>

              </section>
            </div>
          </div>
        </div>
      </main>
      <Toaster
        position="bottom-center"
        toastOptions={{
          className: '',
          style: {
            borderRadius: '30px',
            background: '#333',
            color: '#fff',
          },
        }}
      />
    </div>
  );
}
